/**
 * Resolve landing-blog images by article slug.
 * Convention: src/assets/img/landing-blog/{slug}.jpg|.jpeg|.png|.webp
 *
 * Webpack discovers every matching file via require.context. The explicit
 * requires below keep Jest (no require.context) working for the landing cards.
 */
import { BLOG_POSTS } from '../../service/seoMeta';

const bySlug = {
  'being-a-football-manager': require('../../assets/img/landing-blog/being-a-football-manager.jpg'),
  'evolution-of-football-manager-games': require('../../assets/img/landing-blog/evolution-of-football-manager-games.jpg'),
  'online-football-manager-games': require('../../assets/img/landing-blog/online-football-manager-games.jpg'),
};

if (typeof require.context === 'function') {
  const imageContext = require.context(
    '../../assets/img/landing-blog',
    false,
    /^\.\/.+\.(jpe?g|png|webp)$/
  );
  imageContext.keys().forEach((key) => {
    const base = key.replace(/^\.\//, '').replace(/\.(jpe?g|png|webp)$/i, '');
    bySlug[base] = imageContext(key);
  });
}

export const blogImageForSlug = (slug) => {
  if (!slug) return null;
  return bySlug[slug] || null;
};

export const LANDING_BLOG_LIMIT = 3;

/** Newest seoMeta posts that have a matching landing-blog/{slug} image. */
export const landingBlogArticles = (limit = LANDING_BLOG_LIMIT) => {
  const withImages = [];
  for (const post of BLOG_POSTS) {
    const image = blogImageForSlug(post.slug);
    if (!image) continue;
    withImages.push({ ...post, image });
    if (withImages.length >= limit) break;
  }
  return withImages;
};
